import { useSettings } from "@/context/SettingsContext";

const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const WM_POSITIONS = [
  { value: "pattern", label: "Узором по всему фото" },
  { value: "top-left", label: "Левый верхний угол" },
  { value: "top-right", label: "Правый верхний угол" },
  { value: "bottom-left", label: "Левый нижний угол" },
  { value: "bottom-right", label: "Правый нижний угол" },
  { value: "center", label: "По центру" },
];

const POS_CLASS = {
  "top-left": "top-3 left-3",
  "top-right": "top-3 right-3",
  "bottom-left": "bottom-3 left-3",
  "bottom-right": "bottom-3 right-3",
  center: "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
};

export const watermarkUrl = ({ text = "ПРОМ-ПЛАСТИК", opacity = 28, size = 17, color = "#ffffff" } = {}) => {
  const s = Number(size) || 17;
  const w = Math.round(Math.max(240, String(text).length * s * 0.8 + 40));
  const h = Math.round(s * 9);
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${w}' height='${h}'><text x='8' y='${Math.round(h * 0.64)}' font-family='Arial, Helvetica, sans-serif' font-size='${s}' font-weight='700' letter-spacing='1.5' fill='${esc(color)}' fill-opacity='${(Number(opacity) || 0) / 100}' transform='rotate(-22 ${w / 2} ${h / 2})'>${esc(text)}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export default function WatermarkOverlay({ className = "", preview }) {
  const ctx = useSettings();
  const s = preview || ctx?.settings || {};
  const text = s.wm_text ?? "ПРОМ-ПЛАСТИК";
  const opacity = s.wm_opacity ?? 28;
  const size = s.wm_size ?? 17;
  const color = s.wm_color || "#ffffff";
  const position = s.wm_position || "pattern";

  if (position !== "pattern" && POS_CLASS[position]) {
    return (
      <div aria-hidden="true" data-testid="watermark-overlay" data-position={position} className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}>
        <span
          className={`absolute whitespace-nowrap font-bold tracking-wider select-none ${POS_CLASS[position]}`}
          style={{ color, opacity: opacity / 100, fontSize: `${size}px`, fontFamily: "Arial, Helvetica, sans-serif", textShadow: "0 1px 2px rgba(0,0,0,0.25)" }}
        >
          {text}
        </span>
      </div>
    );
  }

  return (
    <div
      aria-hidden="true"
      data-testid="watermark-overlay"
      data-position="pattern"
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{ backgroundImage: `url("${watermarkUrl({ text, opacity, size, color })}")`, backgroundRepeat: "repeat", mixBlendMode: "overlay" }}
    />
  );
}
